


const page           = require('../../../../components/page/page')
const chartjs        = require('../../../../components/chart/chartjs')
const matn           = require('../../../../js-handler/math')

const allCharts   = { investorHome_page_graph:   { html:'', chart: '',  },
}

//const historynurseDt = require('./historynurse-dt')

import warehousehomePage       from "./warehousehome-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ //console.log('goku init>')
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", warehousehomePage)

   //historynurseDt.start({"dest":"historynurse", "elem":"dt", "act":"select", "entity":"historynurse"})

   allCharts.investorHome_page_graph.html    = document.getElementById('investorHome_page_graph')

  // console.log('targetChart >', targetChart)
  

		chartjs.start({elem:'bar', act:'createSimple', 
	                       targetChart: allCharts.investorHome_page_graph, 
				              data:patientsCompliances, 
	                       options:{ aspectRatio: 4/4, legend: false }   })

}/*init*/

/****************ELEMENTS*****************/



export function start(detail){ //console.log('investor page >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	 obj[detail.act].start(detail)
}




const obj = {
   
      show:  { start: (detail)=>{  page.start(detail)     }},


}/**/



const patientsCompliances = [
		      {
		            label:'Invested',
		            borderRadius: 0,
		            borderWidth:2,
		            color:'blue',
		            value: [ { x: 'Jul', y: 9000}, ]
		      },
		      {
		            label:'Earned',
		            borderRadius: 0,
		            borderWidth:2,
		            color:'green',
		            value: [
		                      { x: 'Jul', y: 900},
		                  ]
		      },

		      {
		            label:'On hold',
		            borderRadius: 0,
		            borderWidth:2,
		            color:'red',
		            value: [
		                      { x: 'Jul', y: 4000},
		                      

		                  ]
		      },

		      {
		            label:'ready',
		            borderRadius: 0,
		            borderWidth:2,
		            color:'purple',
		            value: [
		                      { x: 'Jul', y: 5300},
		                      

		                  ]
		      },




		]